webpackJsonp([188813165217535],{

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(35);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactTwitterWidgets = __webpack_require__(55);
	
	var _reactHelmet = __webpack_require__(27);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'container main-section' },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Paul Kimbrel - Web Developer and Systems Architect, Sound Engineer.' }),
	        _react2.default.createElement('link', { type: 'text/css', href: '/audio/blue.monday/jplayer.blue.monday.css', rel: 'stylesheet' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-8 level-one' },
	                _react2.default.createElement(
	                    'article',
	                    null,
	                    _react2.default.createElement(
	                        'header',
	                        null,
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'My Music'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'If you ask me what I do for a living, the answer is easy. I\'m a computer programmer. I\'ve had all sorts of titles and responsibilities, and as I get older I\'m doing more design and architecture. But at my core, I\'m a computer programmer. I have been since I was 9 years old.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'However, if you were to ask me what I\'d rather do for a living, it would be to record music. I\'ve always loved music - and in a way that\'s hard to explain. Anyone can love music, but there\'s something that music does to my core being that\'s beyond visceral. As an intellectual, I struggle with the spiritual. However, through music I feel I can reach my spirit.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Growing up, I took piano lessons. I can\'t say I cared for it. It was too rigid and didn\'t teach me what I wanted to know. The stress of practice and recitals took the joy out of music and really turned me off from playing any instrument. However, I devoured recorded albums. I studied them. I would listen for hours on end to the same tape - wearing it thin to the point that it ran an octave lower. I heard parts in recordings that most people would ignore - and I attached myself to those parts. In a way, they became a part of me.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Then in college, I had the opportunity to meet some guys that were interested in recording an album. Classic "me" offered to do it without any prior experience or knowledge. It was messy. It didn\'t turn out great. But it was real - and I had a part in creating it. It started a land slide that has continued to this day.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'For about 10 years, I ran Shadow Closet Studios. The name came from the first apartment my friends and I used to record that album. We used a walk-in closet as a vocal booth. Did it really help? Nope. But we didn\'t know that at the time, and it was fun. My studio grew - I recorded more artists, but then life crept in.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'I have no regrets of moving forward with life. To record music full time was an endeavor that required so much of me, I would have had nothing left for my loved ones. Over time the contracts shrank up, the equipment went unused. Our family moved and the studio didn\'t come with us. I still have the gear and I have a small niche to play around in. But recording isn\'t on the horizon until we launch our children out into the world.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Posted here are a few of my own personal tracks that I recorded. They\'re not the best recordings in the world - and certainly not the best songs known to man. But they are a part of who I am - or at least who I was. When the time comes that I record again - it will be fun to hear how things have changed.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Many people have contributed to this music. But I have to recognize two guys in particular. Steve Hampton was my best friend in college and a spiritual partner. He plays the guitar in many of these tracks and was the guy that really helped me capture what was in my brain - and recorded on disk. Chad Lemons was the guy that started this stuff. It was his album that got the ball rolling. His encouragement and guitar playing are seen here as well.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'And there are many more - I\'ll try to remember who all was involved. If I missed you - please accept my apologies. You have permission to write me a nasty letter. At least then I\'ll know where I need to update my website.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'article',
	                    null,
	                    _react2.default.createElement(
	                        'header',
	                        null,
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'One Fine Day'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'This is probably my favorite song (of what I\'ve written). It started out as a simple acoustic guitar riff (as heard at the beginning) and mushroomed from there. In particular, the drums and bass added a whole new dimension to the song that we played on as we recorded the vocals. But it was missing so much. Then Chad came into town for a visit. In one night - he completed the song with some of the best funk guitar licks I could never imagine.'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://d2w1qdj4e6t7jo.cloudfront.net/PaulKimbrel/OneFineDay.mp3' },
	                        _react2.default.createElement('i', { className: 'fa fa-cloud-download' }),
	                        ' Download'
	                    )
	                ),
	                _react2.default.createElement(
	                    'article',
	                    null,
	                    _react2.default.createElement(
	                        'header',
	                        null,
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Beyond a Doubt'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'This song was an accident. Steve and I were playing with an echo pedal when found a great timing and an awesome riff. It\'s not a terribly original riff, but it was inspiring. So we went through the bank of lyrics and found something that fit. I hooked up a mic and sang while Steve played. Both are what you hear on this recording. We tried to improve both, and failed - the original stuck.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Oh, and that bass line. It was also an accident. Probably why this song is the best of the bunch.'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://d2w1qdj4e6t7jo.cloudfront.net/PaulKimbrel/02_Beyond_A_Doubt.mp3' },
	                        _react2.default.createElement('i', { className: 'fa fa-cloud-download' }),
	                        ' Download'
	                    )
	                ),
	                _react2.default.createElement(
	                    'article',
	                    null,
	                    _react2.default.createElement(
	                        'header',
	                        null,
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Someone Special'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'I wrote the words to this song when I was particularly lonely (it was before I started dating Tonya). Ironically, I didn\'t record it until after I was married. However, the words fit well into the chords we were working on. The chords were something I had been noodling with for about a year and Steve took it made it actually work.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'I\'m not the best lyricists in the world, but every once in a while I stumble upon a jewel our two. This song has one: "Patience is a virtue that I never seem to master." Yep. Not sure how I cooked that one up.'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://d2w1qdj4e6t7jo.cloudfront.net/PaulKimbrel/03_Someone_Special.mp3' },
	                        _react2.default.createElement('i', { className: 'fa fa-cloud-download' }),
	                        ' Download'
	                    )
	                ),
	                _react2.default.createElement(
	                    'article',
	                    null,
	                    _react2.default.createElement(
	                        'header',
	                        null,
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Where Are You Now'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'I\'ll let you draw your own conclusions as to the meaning of the song. However, I will say this song took way too long to write and produce - but the results were worth it. Steve and I started this in college and didn\'t get the final chords figured out until... long after college. It only took 3 or 4 complete rewrites.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'I never got that guitar solo in the pre-bridge. But that\'s okay. I got the right B3 organ sound and that\'s all that matters.'
	                    ),
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://d2w1qdj4e6t7jo.cloudfront.net/PaulKimbrel/04_Where_Are_You_Now.mp3' },
	                        _react2.default.createElement('i', { className: 'fa fa-cloud-download' }),
	                        ' Download'
	                    )
	                ),
	                _react2.default.createElement(
	                    'article',
	                    null,
	                    _react2.default.createElement(
	                        'header',
	                        null,
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Other songs I\'ve not written about yet'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://d2w1qdj4e6t7jo.cloudfront.net/PaulKimbrel/04_Where_Are_You_Now.mp3' },
	                                'Where Are You Now'
	                            ),
	                            ' - this one started it all off, but doesn\'t sound anyting like the first cut'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://d2w1qdj4e6t7jo.cloudfront.net/PaulKimbrel/06_One_Of_These_Days.mp3' },
	                                'One Of These Days'
	                            ),
	                            ' - weird song; never finished it; kinda hate it'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://d2w1qdj4e6t7jo.cloudfront.net/PaulKimbrel/07_When_Time_Stood_Still.mp3' },
	                                'When Time Stood Still'
	                            ),
	                            ' - strange song, but my absolute favorite'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://d2w1qdj4e6t7jo.cloudfront.net/PaulKimbrel/08_Someone_Special_Reprise.mp3' },
	                                'Someone Special (Reprise)'
	                            ),
	                            ' - i made a reprise; aren\'t i clever'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://d2w1qdj4e6t7jo.cloudfront.net/PaulKimbrel/09_All_I_Need.mp3' },
	                                'All I Need'
	                            ),
	                            ' - dedicated to my wife - probably the most solid song of mine i\'ve recorded'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://d2w1qdj4e6t7jo.cloudfront.net/PaulKimbrel/PK_into_the_waves.mp3' },
	                                'Into the Waves'
	                            ),
	                            ' - small moment of inspiration; yes it\'s techno - way easier than real drums'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://d2w1qdj4e6t7jo.cloudfront.net/PaulKimbrel/PK_who_knows_mixdown03.mp3' },
	                                'Who Knows'
	                            ),
	                            ' - quickest we ever wrote and recorded a song'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://d2w1qdj4e6t7jo.cloudfront.net/PaulKimbrel/40.mp3' },
	                                '40'
	                            ),
	                            ' - Cover of U2\'s "40"'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-sm-4 level-two' },
	                _react2.default.createElement(
	                    'sidebar',
	                    null,
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Music Stream'
	                    ),
	                    _react2.default.createElement('div', { id: 'jquery_jplayer_1', className: 'jp-jplayer' }),
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'jp_container_1', className: 'jp-audio' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'jp-type-playlist' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'jp-gui' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'jp-interface' },
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: 'jp-controls' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: 'javascript:;', className: 'jp-previous', tabIndex: '1' },
	                                                'previous'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: 'javascript:;', className: 'jp-play', tabIndex: '1' },
	                                                'play'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: 'javascript:;', className: 'jp-pause', tabIndex: '1' },
	                                                'pause'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: 'javascript:;', className: 'jp-next', tabIndex: '1' },
	                                                'next'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: 'javascript:;', className: 'jp-mute', tabIndex: '1' },
	                                                'mute'
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: 'javascript:;', className: 'jp-unmute', tabIndex: '1' },
	                                                'unmute'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'jp-volume-bar' },
	                                        _react2.default.createElement('div', { className: 'jp-volume-bar-value' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'jp-interface jp-secondary' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'jp-details' },
	                                        _react2.default.createElement(
	                                            'ul',
	                                            null,
	                                            _react2.default.createElement(
	                                                'li',
	                                                null,
	                                                _react2.default.createElement('span', { className: 'jp-title' })
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'jp-progress' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'jp-seek-bar' },
	                                            _react2.default.createElement('div', { className: 'jp-play-bar' })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'jp-time-holder' },
	                                        _react2.default.createElement('div', { className: 'jp-current-time' }),
	                                        _react2.default.createElement('div', { className: 'jp-duration' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'jp-no-solution' },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    'Update Required'
	                                ),
	                                'To play the media you will need to update your browser to a more recent version.'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'jp-playlist' },
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    _react2.default.createElement('li', null)
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-music-index-js-5aca2898fbd7c0ddaf01.js